import { TableDataType } from 'module/ui/components/atoms/rich-text-editor/toolbar/table-toolbar';
import { BaseCustomSectionAttributes, CustomSectionType } from './common';

export enum answerFrom {
  Customer = 'CUSTOMER',
  Vendor = 'VENDOR',
  All = 'ALL',
}

export enum AnswerLength {
  TwentyWords = 20,
  HundredWords = 100,
  TwoHundredWords = 200,
  FiveHundredWords = 500,
}

export type MultiQuestionCustomSectionConfig = {
  questions: {
    question: string;
    id: string;
    dataType: TableDataType;
    choices?: string[];
    generateNewChoices?: boolean;
    aiContext?: string;
    answerFrom?: string;
    answerLength?: number | null;
  }[];
};
export type MultiQuestionCustomSectionAttributes =
  BaseCustomSectionAttributes & {
    sectionType: CustomSectionType.MultiQuestion;
    config: {
      questions: {
        question: string;
        id: string;
        dataType: TableDataType;
        choices?: string[];
        generateNewChoices?: boolean;
        aiContext?: string;
        answerFrom?: string;
        answerLength?: number | null;
      }[];
    };
  };
